export class LoanOptionApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getConfiguration(body) {
    return this.#http.post('/api/loan-options/configuration', body);
  }
}
